export const strings = {
  noFileSelected: 'No file selected',
}

export type FileViewerStrings = typeof strings
